<!-- eslint-disable vue/no-multiple-template-root -->
<template>
    <a
        v-if="showReportRibbon"
        class="report-ribbon"
        href="/state-of-ux-portfolios-2026"
        style="display:flex;justify-content:center;align-items:center;width:100%;min-height:52px;padding:14px 16px;background-color:#DCFA37;color:#0F0F0F;text-decoration:none;text-align:center;box-sizing:border-box;"
    >
        <span
            class="report-ribbon-text"
            style="font-family:'Inter Tight',system-ui,sans-serif;font-size:15px;font-weight:500;line-height:22px;letter-spacing:0.15px;"
        >
            State of UX Portfolios 2026: how portfolios actually get reviewed.
            <span class="report-ribbon-cta">
                <span class="report-ribbon-cta-label">Get the report</span>
                <span class="report-ribbon-cta-arrow" aria-hidden="true">→</span>
            </span>
        </span>
    </a>

    <div v-if="emergencyModeSettings && emergencyModeSettings.emergencyMode && emergencyModeSettings.landingEmergencyBanner" class="alert-banner-container">
        <div class="banner-content-container">
            <div class="banner-text-container">
                <div class="info-icon">
                    <Icon :icon-name="'info'" />
                </div>
                <div class="message">
                    {{ emergencyModeSettings.landingEmergencyBannerText }}
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!showReportRibbon" class="divider"></div>

    <header :class="{ 'show-border': shouldShowNavigationBorder }">

        <div class="content">
            <div class="logo">
                <router-link to="/">
                    <UXFolioLogo />
                </router-link>
            </div>

            <template v-if="!referral && !comingSoon">
                <nav :class="{'on' : mobileNavOpen}">
                    <component v-for="item in navItems"
                               :key="item.id"
                               :is="!item.external ? 'router-link' : 'a'"
                               :to="!item.external ? item.route : null"
                               :href="item.route"
                    >
                    <span :data-label="item.label">
                        {{ item.label }}
                    </span>
                        <ArrowIcon :size="28" class="mobile-nav-arrow" />
                    </component>
                    <CtaButton type="secondary" :no-arrow="true" :hover-arrow-on-no-arrow="true" label="Log in" class="login" @click="goToLogin()" />
                </nav>
            </template>

            <div class="actions">
                <CtaButton v-if="!referral" type="secondary" :no-arrow="true" :hover-arrow-on-no-arrow="true" label="Log in" class="login" @click="goToLogin()" />
                <CtaButton :id="referral ? 'signup_referral_button_nav' : 'signup_button_nav'" :no-arrow="true" :hover-arrow-on-no-arrow="true" label="Sign up" @click="goToSignup()" />
                <CtaButton type="secondary" class="toggler" @click="toggleMobileNav()">
                    <HamburgerIcon />
                </CtaButton>
            </div>
        </div>

    </header>
</template>

<script>
import UXFolioLogo from "../icons/UXfolioLogo.vue";
import HamburgerIcon from "../icons/HamburgerIcon.vue";
import ArrowIcon from "../icons/ArrowIcon.vue";
import CtaButton from "./CtaButton.vue";
import {useHead} from "@unhead/vue";
import Icon from "../../../common/Icon.vue";
import ApiHelper from "@/scripts/api/ApiHelper.js";
import {getLandingPageName, trackLandingCtaClick} from "../utilities/landingCtaTracking.js";
import {mapGetters} from "vuex";
import {loginTo, registerTo} from "@/scripts/auth/keycloakAuth.js";

let head = null;

    export default {
        name: "HeaderPage",
        props: {
          referral: {
              type:Boolean, //This is to remove some buttons for referral page, default it's false
              default:false
          },
          comingSoon: {
              type: Boolean,
              default: false
          },
          noArrowButtons: {
              type: Boolean,
              default: true
          },
        },
        components: {
            Icon,
            UXFolioLogo,
            HamburgerIcon,
            ArrowIcon,
            CtaButton
        },
        beforeCreate() {
            head = useHead({
                link: [
                    {rel: "preconnect", href: "https://fonts.googleapis.com"},
                    {rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: true},
                    {rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&family=Work+Sans:ital,wght@0,100..900;1,100..900&family=Inter+Tight:wght@400;500;600;700&display=swap"},
                ]
            })
        },
        beforeMount() {
            if (!this.comingSoon) {
                this.getEmergencyModeSettings();
            }
        },
        data() {
            return {
                navItems: [
                    {
                        id: 1,
                        label: "Examples",
                        route: "/examples"
                    },
                    {
                        id: 2,
                        label: "Pricing",
                        route: "/pricing"
                    },
                    {
                        id: 3,
                        label: "Blog",
                        route: "https://blog.uxfol.io/",
                        external: true
                    },
                ],
                mobileNavOpen: false,
                navigationScrolled: false
            }
        },
        mounted() {
            window.addEventListener("scroll", this.updateNavigationBorder, { passive: true });
            this.updateNavigationBorder();
        },
        beforeUnmount() {
            window.removeEventListener("scroll", this.updateNavigationBorder);
        },
        methods: {
            goToSignup() {

                const utmCampaignSource = this.$route.fullPath === "/" ? "/landing" : this.$route.fullPath.includes("/referral") ? "/referral" : this.$route.fullPath.includes("/examples/") ? "/examples" : this.$route.fullPath;
                const referral = this.$route.params.referral_id;

                trackLandingCtaClick("Sign up", getLandingPageName(this.$route.path), "Header", utmCampaignSource, {
                    mode: this.viewData.publicPages.activeMode,
                    referral_id: this.$route.params.referral_id,
                    destination: "/home/onboarding",
                });

                return registerTo('/home/onboarding', {
                    mode: this.viewData.publicPages.activeMode,
                    referral,
                    utm_source: utmCampaignSource,
                    utm_campaign: 'header',
                });
            },
            goToLogin() {
                const utmCampaignSource = this.$route.fullPath === "/" ? "/landing" : this.$route.fullPath;

                trackLandingCtaClick("Log in", getLandingPageName(this.$route.path), "Header", utmCampaignSource, {
                    mode: this.viewData.publicPages.activeMode,
                    destination: "/home",
                });

                return loginTo('/home');
            },
            async getEmergencyModeSettings() {
                try {
                    let res = await ApiHelper.get('/data/emergency')
                    this.viewData.emergencyModeSettings = res.data;
                } catch (error) {
                    this.viewData.emergencyModeSettings = null;
                }
            },
            navigate(evt, route) {
                evt.preventDefault();
                this.toggleMobileNav(false);
                this.$router.push(route);
            },
            scrollTo(evt, hash) {
                evt.preventDefault();
                this.toggleMobileNav(false);

                if(this.$route.fullPath === "/") {
                    this.$router.push({ hash: hash })
                } else {
                    this.$router.push({name: "Index", hash: hash })
                }
            },
            toggleMobileNav(val) {
                this.mobileNavOpen = val !== undefined ? val : !this.mobileNavOpen;
            },
            updateNavigationBorder() {
                const navigationScrolled = window.scrollY > 4;

                if (this.navigationScrolled !== navigationScrolled) {
                    this.navigationScrolled = navigationScrolled;
                }
            }
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            emergencyModeSettings() {
                return this.viewData.emergencyModeSettings;
            },
            showReportRibbon() {
                const path = this.$route.path;
                return path === "/"
                    || path === "/pricing"
                    || path === "/examples"
                    || path.startsWith("/examples/");
            },
            shouldShowNavigationBorder() {
                return this.$route.fullPath !== "/" || this.navigationScrolled;
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../styles/public-pages/components/header";
</style>

<style lang="scss" global>
.alert-banner-container {
    min-height: 56px;
    width: 100%;
    background-color: #DCFA37;
    display: flex;
    justify-content: center;
    cursor: pointer;

    @media (max-width: 769px) {
        min-height: 56px;
    }

    @media (max-width: 640px) {
        min-height: 70px;
    }

    .banner-content-container {
        @media (max-width: 769px) {
            padding: 0 62px;
        }

        @media (max-width: 640px) {
            padding: 0;
        }

        .banner-text-container {
            padding: 16px;
            display: flex;

            @media (max-width: 640px) {
                padding: 12px 6px;
            }

            .info-icon {
                @media (max-width: 640px) {
                    font-size: 12px;
                }

                svg {
                    height: 23px;
                    color:  #0F0F0F;
                }
            }

            .message {
                margin-left: 8px;
                color: #0F0F0F;
                font-family: var(--primarySans);
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px; /* 150% */
                letter-spacing: 0.16px;

                @media (max-width: 769px) {
                    font-size: 9px;
                }
            }
        }
    }
}
</style>
